export const truthyFilter = Boolean as any as <T>(
  x: T | false | undefined | null | '' | 0
) => x is T;

export function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message
  return String(error)
}
